<div class="container-back-button">
  <button (click)="goBack()" class="back-button">
    <img
      src="../../../../assets/new-styles/icons/buttons/left-arrow.svg"
      alt=""
    />
    <span class="back-button__label">{{ backLabel }}</span>
  </button>
</div>
